module.exports = __webpack_public_path__ + "static/media/XIe.b1638cea.png";